import { createContext } from 'react';
export var currentSecondaryDimensionContext = createContext('');
